module.exports = __webpack_public_path__ + "static/media/Viking (Series 20).21251dec.jpg";